module.exports = __webpack_public_path__ + "media/images/undraw/feedback-ecc7bc57c21c4f75d3293e759518825d.png";